// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__hLUwo","title":"Header_title__Md3AU"};